import { render, staticRenderFns } from "./week.vue?vue&type=template&id=dc5d527c&scoped=true"
import script from "./week.vue?vue&type=script&lang=js"
export * from "./week.vue?vue&type=script&lang=js"
import style0 from "./week.vue?vue&type=style&index=0&id=dc5d527c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5d527c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc5d527c')) {
      api.createRecord('dc5d527c', component.options)
    } else {
      api.reload('dc5d527c', component.options)
    }
    module.hot.accept("./week.vue?vue&type=template&id=dc5d527c&scoped=true", function () {
      api.rerender('dc5d527c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schedule/week.vue"
export default component.exports